module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('MainRow'), _vm._v(" "), _c('div', {
    staticClass: "container-body"
  }, [_c('div', {
    attrs: {
      "id": "concept-cards"
    }
  }, _vm._l((_vm.types), function(type) {
    return _c('section', {
      key: type.id
    }, [_c('typeRow', {
      attrs: {
        "type": type
      }
    })], 1)
  }), 0)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2879de08","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/mainboard.vue
// module id = WTEJ
// module chunks = 1